import { c as _c } from "react/compiler-runtime";
import { IcoDotsHorizontal16, IcoPencil16, IcoPlusSmall16, IcoTrash16 } from '@onefootprint/icons';
import type { SkillFileNode } from '@onefootprint/request-types/dashboard';
import { Dropdown, IconButton, useConfirmationDialog } from '@onefootprint/ui';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useBuilder } from '../../store/provider';
type SkillActionsProps = {
  node: SkillFileNode;
  path: string;
  onRename?: () => void;
};
const SkillActions = t0 => {
  const $0 = _c(38);
  const {
    node,
    path,
    onRename
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.skills"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const {
    actions,
    isReadOnly
  } = useBuilder();
  const confirm = useConfirmationDialog();
  const afterCloseRef = useRef(null);
  if (isReadOnly) {
    return null;
  }
  let t2;
  if ($0[1] !== actions || $0[2] !== confirm || $0[3] !== node.children || $0[4] !== node.content || $0[5] !== node.kind || $0[6] !== path || $0[7] !== t) {
    t2 = () => {
      const isEmpty = node.kind === "file" ? !node.content : node.children.every(_temp);
      if (isEmpty) {
        actions.skills.remove(path);
        return;
      }
      confirm.open({
        title: t($ => $.confirmDelete.title[node.kind]),
        description: t($_0 => $_0.confirmDelete.description[node.kind]),
        variant: "destructive",
        primaryButton: {
          label: t(_temp2),
          onClick: () => actions.skills.remove(path)
        },
        secondaryButton: {
          label: t(_temp3)
        }
      });
    };
    $0[1] = actions;
    $0[2] = confirm;
    $0[3] = node.children;
    $0[4] = node.content;
    $0[5] = node.kind;
    $0[6] = path;
    $0[7] = t;
    $0[8] = t2;
  } else {
    t2 = $0[8];
  }
  const remove = t2;
  let t3;
  if ($0[9] !== node.name || $0[10] !== t) {
    t3 = t(_temp4, {
      name: node.name || t(_temp5)
    });
    $0[9] = node.name;
    $0[10] = t;
    $0[11] = t3;
  } else {
    t3 = $0[11];
  }
  let t4;
  if ($0[12] !== t3) {
    t4 = <Dropdown.Trigger asChild={true}><IconButton icon={IcoDotsHorizontal16} variant="ghost" size="compact" aria-label={t3} /></Dropdown.Trigger>;
    $0[12] = t3;
    $0[13] = t4;
  } else {
    t4 = $0[13];
  }
  let t5;
  if ($0[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = event => {
      const afterClose = afterCloseRef.current;
      if (!afterClose) {
        return;
      }
      event.preventDefault();
      afterCloseRef.current = null;
      afterClose();
    };
    $0[14] = t5;
  } else {
    t5 = $0[14];
  }
  let t6;
  if ($0[15] !== onRename || $0[16] !== t) {
    t6 = onRename && <Dropdown.Item iconLeft={IcoPencil16} onSelect={() => {
      afterCloseRef.current = onRename;
    }}>{t(_temp6)}</Dropdown.Item>;
    $0[15] = onRename;
    $0[16] = t;
    $0[17] = t6;
  } else {
    t6 = $0[17];
  }
  let t7;
  if ($0[18] !== actions || $0[19] !== node.kind || $0[20] !== path || $0[21] !== t) {
    t7 = node.kind === "folder" && <Dropdown.Item iconLeft={IcoPlusSmall16} onSelect={() => {
      afterCloseRef.current = () => actions.skills.addFile(path);
    }}>{t(_temp7)}</Dropdown.Item>;
    $0[18] = actions;
    $0[19] = node.kind;
    $0[20] = path;
    $0[21] = t;
    $0[22] = t7;
  } else {
    t7 = $0[22];
  }
  let t8;
  if ($0[23] !== remove) {
    t8 = () => {
      afterCloseRef.current = remove;
    };
    $0[23] = remove;
    $0[24] = t8;
  } else {
    t8 = $0[24];
  }
  let t9;
  if ($0[25] !== node.kind || $0[26] !== t) {
    t9 = node.kind === "folder" ? t(_temp8) : t(_temp9);
    $0[25] = node.kind;
    $0[26] = t;
    $0[27] = t9;
  } else {
    t9 = $0[27];
  }
  let t10;
  if ($0[28] !== t8 || $0[29] !== t9) {
    t10 = <Dropdown.Item iconLeft={IcoTrash16} destructive={true} onSelect={t8}>{t9}</Dropdown.Item>;
    $0[28] = t8;
    $0[29] = t9;
    $0[30] = t10;
  } else {
    t10 = $0[30];
  }
  let t11;
  if ($0[31] !== t10 || $0[32] !== t6 || $0[33] !== t7) {
    t11 = <Dropdown.Content align="end" onCloseAutoFocus={t5}>{t6}{t7}{t10}</Dropdown.Content>;
    $0[31] = t10;
    $0[32] = t6;
    $0[33] = t7;
    $0[34] = t11;
  } else {
    t11 = $0[34];
  }
  let t12;
  if ($0[35] !== t11 || $0[36] !== t4) {
    t12 = <Dropdown.Root>{t4}{t11}</Dropdown.Root>;
    $0[35] = t11;
    $0[36] = t4;
    $0[37] = t12;
  } else {
    t12 = $0[37];
  }
  return t12;
};
export default SkillActions;
function _temp(child) {
  return child.kind === "file" && !child.content;
}
function _temp2($_1) {
  return $_1.confirmDelete.confirm;
}
function _temp3($_2) {
  return $_2.confirmDelete.cancel;
}
function _temp4($_3) {
  return $_3.actions;
}
function _temp5($_4) {
  return $_4.untitled;
}
function _temp6($_5) {
  return $_5.rename;
}
function _temp7($_6) {
  return $_6.addFile;
}
function _temp8($_7) {
  return $_7.removeSkill;
}
function _temp9($_8) {
  return $_8.removeFile;
}